module.exports = __webpack_public_path__ + "assets1783936157458/img/yanshi.1c28f795.svg";